import { Routes, Route, Navigate } from "react-router-dom";
import Login from "@pages/auth/login";
import RoutesInstance from "./instances";

const AuthRoutes = () => {
    return (
        <Routes>
            <Route path={RoutesInstance.login}>
                <Route index element={<Login />} />
            </Route>

            <Route
                path="*"
                element={<Navigate to={RoutesInstance.login} replace />}
            />
        </Routes>
    );
};

export default AuthRoutes;
